import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, map } from 'rxjs';
import { environment } from 'src/app/enviroments/enviroment';
import { IIPLookupService } from 'src/app/interfaces/ip-lookup-service.interface';

@Injectable({
  providedIn: 'root',
})
export class IpinfoService implements IIPLookupService {
  constructor(private http: HttpClient) {}

  getIp(): Promise<string> {
    const ipInfoToken = environment.ipInfoToken;
    return lastValueFrom(
      this.http.get<{ ip: string }>(`https://ipinfo.io/json?token=${ipInfoToken}`).pipe(map(({ ip }) => ip)),
    );
  }
}
